import { render, staticRenderFns } from "./toDo.vue?vue&type=template&id=bd8f965a&scoped=true&"
import script from "./toDo.vue?vue&type=script&lang=js&"
export * from "./toDo.vue?vue&type=script&lang=js&"
import style0 from "./toDo.vue?vue&type=style&index=0&id=bd8f965a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8f965a",
  null
  
)

export default component.exports